<template>
  <div class="container">
    <Head :showLeftIcon="true"  title="我的课程" />
    <div class="my-info">
      <div class="channel-info">
        <img :src="logoUrl" alt class="channel-img" />
        <span  class="channel-name">{{channelName}}</span>
      </div>
      <div class="mine-info">
        <span v-if="tourist == 'false'"  class="info-number">{{loginName}}</span>
        <span v-if="tourist == 'true' "  class="info-number">游客登录</span>
        <span @click="loginout" class="loginout">退出</span>
      </div>
    </div>
    <div class="course-box" v-if="myCourseDataList.length > 0">
      <div class="course-title">我的课程</div>
      <MyCourseItem :course-data="item" :key="index" v-for="(item,index) in myCourseDataList"></MyCourseItem>
    </div>
    <div style="height:5px"></div>
    <div class="course-box" v-if="recommendCourseDataList.length > 0">
      <div class="course-title">推荐课程</div>
      <RecommendCourseItem
        :course-data="item"
        :key="index"
        v-for="(item,index) in recommendCourseDataList"
      ></RecommendCourseItem>
    </div>
  </div>
</template>
<script>
import Head from '@/components/h5/Head'
import MyCourseItem from '@/components/h5/MyCourseItem'
import RecommendCourseItem from '@/components/h5/RecommendCourseItem'
import * as INFO_API from '@/api/ChannelCustomerCourseAPI'
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
export default {
  data () {
    return {
      myCourseDataList: [], //我的课程
      recommendCourseDataList: [], //推荐课程
      loginName: '',
      channelName: '',
      logoUrl: '',
      tourist : localStorage.getItem('tourist')  || sessionStorage.getItem('tourist')

    }
  },
  mounted () {
    this.ChannelFindInfo()
    this.loginName = localStorage.getItem('shangke_username')
    // 初始化数据的接口

  if(this.tourist == 'true'){
    if (this.$route.params.h5ChannelLogin) {
      this.recommendCourseDataList = this.$route.params.data.recommendCourseList
    } else {
      this.recommendCourseDataList = JSON.parse(sessionStorage.getItem('h5ChannelLogin')).data.recommendCourseList
    }
    if(this.recommendCourseDataList==null){
       let data = {
        tourist: this.tourist ,
      }
    CHANNEL_INFO_API.ChannelLOgin(data)
        .then(res => {
          if (res.code === 0) {
               this.recommendCourseDataList= res.data.recommendCourseList
          } else {
            console.log(res)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }

  }else{
    this.MyCourse()
  }
  },
  methods: {
    loginout () {
      this.$router.push({ path: '/h5/login', query: { c_no: sessionStorage.getItem('c_no') || localStorage.getItem('c_no') } });
    },

    ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
          this.channelName = res.data.channelName,
          this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
      })
    },

    MyCourse () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let data = {
        loginName: localStorage.getItem('shangke_username')
      }
      INFO_API.MyCourse(data).then(res => {
        loading.close();
        console.log(res)
          this.myCourseDataList = res.data.courseEntityList,
          this.recommendCourseDataList = res.data.recommendCourseList
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },
  },
  components: { Head, MyCourseItem, RecommendCourseItem }
}
</script>
<style lang="less" scoped>
.my-info {
  width: 100%;
  height: 105px;
  background: url(~@/assets/img/h5/my/mybg.png) center/100% 100% no-repeat;
  overflow: hidden;
  .channel-info {
    margin: 15px 30px;
  }
  .channel-img {
    width: 41px;
    height: 41px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .channel-name {
    margin-left: 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 18px;
    vertical-align: middle;
  }
  .mine-info {
    margin: 15px 25px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    background: url(~@/assets/img/h5/my/innerbg.png) center/100% 100% no-repeat;
    .info-number {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
    }
    .loginout {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(59, 23, 4, 1);
      line-height: 18px;
      width: 46px;
      height: 18px;
      background: linear-gradient(
        128deg,
        rgba(245, 207, 160, 1) 0%,
        rgba(250, 234, 211, 1) 100%
      );
      border-radius: 9px;
      text-align: center;
    }
  }
}
.course-box {
  padding: 20px 15px;
  background: #fff;
}
.course-title {
  margin-bottom: 10px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
}
</style>